var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAboutMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1744969991370,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2623,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M525.115 102.747C295.293 91.886 101.865 280.332 102.68 514.302c1.042 299.323 315.278 496.419 585.235 366.942 12.6-6.044 25.337-12.554 36.337-21.019 19.457-14.971 23.51-35.909 11.617-53.267-12.466-18.197-29.882-21.424-49.391-13.49-10.05 4.089-19.053 10.686-28.968 15.183-126.788 57.521-248.04 46.336-355.218-41.8-108.744-89.422-144.926-208.297-109.188-344.74 43.652-166.65 217.05-270.851 384.18-234.68 176.103 38.11 290.047 200.222 259.849 374.826-7.028 40.643-25.908 79.38-40.654 118.495-10.066 26.706-6.713 45.459 13.205 56.788 19.54 11.113 38.753 4.527 55.148-19.236 3.522-5.108 6.251-10.779 9.186-16.276 24.53-45.955 39.493-95.11 44.948-146.652C944.047 318.377 766 114.132 525.115 102.747z",
    "p-id": 2624
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M564.213 499.079c9.116-42.581-12.606-62.343-55.298-52.903-9.091 2.01-18.233 4.457-26.804 8.018-28.46 11.823-37.786 32.77-20.584 59.12 12.264 18.785 9.472 34.176 4.287 52.447-10.187 35.895-20.615 71.787-28.817 108.16-7.236 32.093 10.072 52.813 42.719 52.508 4.395-0.73 10.576-1.53 16.657-2.806 51.979-10.916 60.285-28.486 38.65-76.8-3.864-8.63-3.364-20.742-1.065-30.333 9.418-39.301 21.803-77.93 30.255-117.411zM589.759 342.95c0.512-24.56-23.067-47.913-47.545-47.088-25.409 0.859-45.789 24.128-43.775 49.986 1.907 24.487 22.18 42.67 46.632 41.827 23.791-0.82 44.198-21.244 44.688-44.725z",
    "p-id": 2625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAboutMe);
export default __webpack_public_path__ + "static/media/icon-about-me.f665af162d3186b5f20a19c110e21f77.svg";
export { ForwardRef as ReactComponent };